export const blogTableHeader = [
    { key: 'id', label: 'id' },
    { key: 'title', label: 'title' },
    { key: 'shortDescription', label: 'shortDescription' },
    { key: 'description', label: 'description' },
    { key: 'createdAt', label: 'createdAt' },
];